<ng-container *ngIf="!accessDenied">
    <div class="w-100 float-left">
        <div *ngIf='mainPage' class="w-100 float-left v-align relative">
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center" (click)="clicked()">
                <h5 class="medium m-0">ROLE-AUTHORIZATION</h5>
                <div style="flex-grow: 1;"></div>
                <!-- <button id="add" (click)="onBack()" class="btn btn-primary float-right mr-3"> Back </button> -->
            </div>
        </div>
    </div>
    <div *ngIf='mainPage ' class="main-table table-custom">
        <div *ngIf='!isEdit' class="w-100 float-left mt-3">
            <div class="form-group" (click)="clicked()">
                <div class='col-lg-6 col-md-6 left-clear'>
                    <label>
                        <h5 class="medium m-0">Role-Authorization Contents</h5>
                    </label>
                </div>
            </div>
            <div *ngIf="(roleList && roleList.length)" class=" overflow:hidden pos-relative diff-table">
                <!-- *ngIf="(roleList && roleList.length) && (pageSectionList && pageSectionList.length)" -->
                <div class="w-100 float-left mt-3" (click)="clicked()">
                    <div class="w-100 float-left p-2 grid-details">
                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left light-bg p-2">
                            <h6 class="mb-lg-0 medium"> Role </h6>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left light-bg p-2">
                            <h6 class="mb-lg-0 medium"> Description </h6>
                        </div>
                        <!-- <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left light-bg p-2">
                            <h6 class="mb-lg-0 medium">Widgets Count </h6>
                        </div> -->
                        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left light-bg p-2">
                            <h6 class="mb-lg-0 medium"> Actions </h6>
                        </div>
                    </div>
                </div>
                <div class="w-100 float-left p-2 grid-details" *ngFor="let roleData of roleList, let i = index">
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                        <h6 class="mb-lg-0 medium"> {{roleData.name}} </h6>
                    </div>
                    <div *ngIf="roleData.description" class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                        <h6 class="mb-lg-0 medium"> {{roleData.description}} </h6>
                    </div>
                    <div *ngIf="!roleData.description" class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                        <h6 class="mb-lg-0 medium"> NA </h6>
                    </div>
                    <!-- <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" >
                        <h6 class="mb-lg-0 medium"> {{countMap.get(roleData.id)}} </h6>
                    </div> -->
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative">
                        <h6 class="mb-lg-0" (click)="tableActions(i)" ngbTooltip="Click for more options">
                            <i class="fa fa-ellipsis-h"></i>
                        </h6>
                        <div class="empActions m-t-nsmd" *ngIf="i == trackHides">
                            <i class="fa fa-caret-up caret-up"></i>
                            <ul class="m-0 p-0">
                                <li (click)="editRoles(roleData.id, roleData.name)">
                                    <i class="fa fa-pencil mr-2"></i> Edit
                                </li>
                                <!-- Add more options -->
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- Pagination -->
                <div *ngIf="(roleList && roleList.length)" class="w-100 float-left my-4 light-bg p-3 align-v-center">
                    <h6 class="float-left mb-0 mr-4"> {{((pageNo-1) * pageSize) + 1}} - {{((pageNo-1) * pageSize) +
                        roleList.length}} items of {{totalRoles}} </h6>
                    <div class="float-left ml-2 align-v-center">
                        <label class="m-0 float-left">Show items per page</label>
                        <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="pageSize"
                                (change)="OnPageSizeChanged($event)">
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                        </select>
                    </div>
                    <div style="flex-grow: 1;"></div>
                    <ngb-pagination [collectionSize]="totalRoles" [rotate]="true" [pageSize]="pageSize"
                                    [ellipses]="false" [maxSize]="totalPages" [boundaryLinks]="true"
                                    [(page)]="pageNo" (pageChange)="onPageChange($event)"
                                    class="float-right"></ngb-pagination>
                </div>
            </div>
            <ng-container *ngIf="(roleList && !roleList.length)">
                <div class="w-100 float-left  mt-3" *ngIf="!loader">
                    <p class="text-center m-0 w-100 medium">No Roles to Load</p>
                </div>
            </ng-container>
        </div>
        <div *ngIf="isEdit">
            <editRoleAuthorization (onEdit)="onEdit($event)" [roleId]="roleId"
                                   [roleName]="roleName"></editRoleAuthorization>
        </div>
    </div>
    <div class="w-100 min-h2 relative" *ngIf="loader">
        <loader></loader>
    </div>


</ng-container>


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/roleAuthorization.component.html